import React from 'react'
import CheckboxField from '@/v2/components/common/CheckboxField'
import { TextField } from '../fields'
import { DENTAL_CONDITIONS } from '../constants'
import {
  StepCard,
  TitleContainer,
  StepIndicator,
  SectionTitle,
  Row,
  FieldWrapper,
} from '../styles'

const OPTIONAL_TEXT = [
  ['dental_pain', 'Do you have dental pain?'],
  ['wisdom_teeth', 'Do you still have your wisdom teeth?'],
  ['lost_teeth', 'Have you lost any teeth?'],
  ['mouth_breather', 'Are you a mouth breather?'],
]

const DentalIssues = ({
  values,
  setValue,
  errors,
  dentalConditions = DENTAL_CONDITIONS,
}) => {
  const selected = values.dental_conditions || []

  const toggle = value => {
    if (selected.includes(value)) {
      setValue('dental_conditions', selected.filter(v => v !== value))
      setValue(value, '') // clear the describe column, matching Rails before_save
    } else {
      setValue('dental_conditions', [...selected, value])
    }
  }

  return (
    <StepCard>
      <TitleContainer>
        <StepIndicator>4</StepIndicator>
        <SectionTitle>Dental Issues</SectionTitle>
      </TitleContainer>

      {OPTIONAL_TEXT.map(([field, label]) => (
        <Row key={field}>
          <FieldWrapper $basis="100%">
            <TextField
              fullWidth
              label={label}
              value={values[field] || ''}
              onChange={v => setValue(field, v)}
            />
          </FieldWrapper>
        </Row>
      ))}

      {dentalConditions.map(({ value, label }) => {
        const checked = selected.includes(value)
        return (
          <div key={value} style={{ marginBottom: 8 }}>
            <CheckboxField
              label={label}
              checked={checked}
              onChange={() => toggle(value)}
            />
            {checked && (
              <FieldWrapper $basis="100%">
                <TextField
                  fullWidth
                  label={`Please describe (${label}) *`}
                  value={values[value] || ''}
                  error={errors[value]}
                  onChange={v => setValue(value, v)}
                />
              </FieldWrapper>
            )}
          </div>
        )
      })}
    </StepCard>
  )
}

export default DentalIssues
